import {Button} from 'src/design/atoms/Button';
import type {ButtonProps} from 'src/design/atoms/Button';

/**
 * "Save" form button — full-width `Button` preset for form-save actions:
 * `variant="filled"`, `fullWidth`, `size="lg"`, defaulting its label to
 * "Save" and its width to `100%` on mobile / `300px` from `sm` up.
 * @registry Full-width primary save button for form footers.
 *
 * Ported from `library-m/components/buttons/FormButton`. Prop surface kept
 * identical (all `Button` props pass through, `children` defaults to "Save"
 * but can still be overridden). One deviation: the original hard-coded
 * `w={{xs: '100%', sm: '300px'}}` after spreading `props`, so callers could
 * never override the width; here `w` is a default like every other prop and
 * can be overridden.
 */
export type SaveButtonProps = ButtonProps;

export const SaveButton = ({
  variant = 'filled',
  fullWidth = true,
  size = 'lg',
  w = {xs: '100%', sm: '300px'},
  children = 'Save',
  ...props
}: SaveButtonProps) => (
  <Button
    variant={variant}
    fullWidth={fullWidth}
    size={size}
    w={w}
    {...props}>
    {children}
  </Button>
);
